class MediaGallery extends HTMLElement {
  constructor() {
    super();
  }

  setActiveMedia(mediaId, prepend) {
    const swiper = this.querySelector('.swiper-main')?.swiper;
    if (!swiper) return;

    const cleanId = mediaId.includes('-') ? mediaId.split('-').pop() : mediaId;

    setTimeout(() => {
      // 在所有 slides（包括 duplicate）里找匹配的 mediaId
      const allSlides = this.querySelectorAll('.swiper-slide');
      let targetIndex = -1;

      allSlides.forEach((slide, i) => {
        const mediaEl = slide.querySelector(`[data-media-id="${cleanId}"]`);
        if (mediaEl && !slide.classList.contains('swiper-slide-duplicate')) {
          // 找到在 swiper.slides 里的真实 index
          const swiperSlides = Array.from(swiper.slides);
          targetIndex = swiperSlides.indexOf(slide);
        }
      });

      if (targetIndex !== -1) {
        swiper.slideToLoop(targetIndex, 300);
      } else {
        // fallback: 回到第一张
        swiper.slideToLoop(0, 300);
      }
    }, 600);
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}